{
    "monster": {
        "key": "monster",
        "jobKey": "book/vampire",
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "page": {
        "key": "page",
        "role": "page",
        "type": "zone",
        "spriteSize": "contained", "imageKey": "book/page1",
        "properties": [
            "no healthbar"
        ],

        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "pageKeys": [
            "mimic"
        ]
    },
    "HGRl4": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "HGRl4",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "9rJwr": {
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "9rJwr",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "BZNYO": {
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "BZNYO",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    }
}
